import Vue from 'vue'
import VueRouter from 'vue-router'
import Situation from '../views/Situation.vue'
import UserGet from '../views/UserGet.vue'
import UserFeature from '../views/UserFeature.vue'
import Login from '../views/login.vue'
import Home from '../views/Home.vue'
import PageSelect from "../views/PageSelect";
import ReportCheckHome from "../views/report/ReportCheckHome";
import FaqHome from "../views/FAQ/FaqHome";
import faq from "../views/FAQ/faq";
import CalendarHome from "../views/calendar/CalendarHome";
import calendarText from "../views/calendar/calendarText";
import calendarImg from "../views/calendar/calendarImg";
import ExtraToolHome from "../views/extratool/ExtraToolHome";
import JKHome from "../views/jk/JKHome";
import UserAnalyseHome from "../views/user/AnalyseHome";

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        redirect: '/pages'
    },
    {
        path: '/analyse',
        name: '统计分析',
        component: Home,
        redirect: '/analyse/situation',
        children: [
            {
                path: 'situation',
                name: '概况',
                component: Situation
            },
            {
                path: 'userGet',
                name: '用户获取',
                component: UserGet
            },
            {
                path: 'userFeature',
                name: '用户特征',
                component: UserFeature
            },
        ]
    },
    {
        path: '/more',
        name: '其他',
        component: Home,
        children: [
            {
                path: 'waite',
                name: '待定',
            },
        ]
    },
    {
        path: '/login',
        name: 'login',
        component: Login
    },
    {
        path: '/pages',
        name: 'pages',
        component: PageSelect
    },
    {
        path: '/report',
        name: 'App反馈',
        component: ReportCheckHome,
        redirect: '/report/checkManager',
        children: [
            {
                path: 'checkManager',
                name: 'CoStudy审核管理',
                component: () => import('../views/report/ReportCheckManager2')
            },
            {
                path: 'checkBlackList',
                name: 'CoStudy封禁列表',
                component: () => import('../views/report/ReportCheckBlackList')
            },
            // {
            //     path: 'checkUser',
            //     name: '用户审核',
            //     component: () => import('../views/report/ReportCheckUser')
            // },
            // {
            //     path: 'checkClassroom',
            //     name: '教室审核',
            //     component: () => import('../views/report/ReportCheckClassroom')
            // },
            {
                path: 'feedback',
                name: 'CoStudy反馈建议',
                component: () => import('../views/report/FeedbackList')
            },
            {
                path: 'CoTimeCheckManager',
                name: 'CoTime审核管理',
                component: () => import('../views/report/CoTimeReportCheckManager2')
            },
            {
                path: 'CoTimeCheckBlackList',
                name: 'CoTime封禁列表',
                component: () => import('../views/report/CoTimeReportCheckBlackList')
            },
        ]
    },
    {
        path: '/extratool',
        name: '辅助功能',
        component: ExtraToolHome,
        redirect: '/extratool/userInfo',
        children: [
            {
                path: 'userInfo',
                name: 'CoStudy用户信息',
                component: () => import('../views/extratool/ToolUserInfo')
            },
            {
                path: 'userCaptcha',
                name: 'CoStudy短信验证码',
                component: () => import('../views/extratool/ToolUserCaptcha')
            }, 
            {
                path: 'userOrderInfo',
                name: 'CoStudy用户订单信息',
                component: () => import('../views/extratool/ToolUserOrderInfo')
            },
            {
                path: 'userOther',
                name: 'CoStudy工具',
                component: () => import('../views/extratool/ToolUserOther')
            },
            {
                path: 'CoTimeUserInfo',
                name: 'CoTime用户信息',
                component: () => import('../views/extratool/CoTimeToolUserInfo')
            },
            {
                path: 'CoTimeUserCaptcha',
                name: 'CoTime短信验证码',
                component: () => import('../views/extratool/CoTimeToolUserCaptcha')
            }, 
            
        ]
    },
    {
        path: '/jk',
        name: '即刻',
        component: JKHome,
        redirect: '/jk/userInfo',
        children: [
            {
                path: 'userInfo',
                name: '用户查询',
                component: () => import('../views/jk/JKUserInfo')
            },
        ]
    },
    {
        path: '/user/analyse',
        name: '用户分析',
        component: UserAnalyseHome,
        redirect: '/user/analyse/list',
        children: [
            {
                path: 'list',
                name: '用户分析',
                component: () => import('../views/user/analyseList')
            },
            {
                path: 'recentAnalysis',
                name: '最近收入分析',
                component: () => import('../views/user/incomeRecentlyAnalysis')
            },
            {
                path: 'figureSellRecentList',
                name: '成衣铺销量统计',
                component: () => import('../views/user/figureSellRecentList')
            },
        ]
    },
    {
        path: '/message',
        name: 'IM消息',
        component: () => import('../views/message/MessageHome'),
        redirect: '/message/messageList',
        children: [
            {
                path: 'messageList',
                name: '消息',
                component: () => import('../views/message/MessageList')
            }
        ]
    },
    {
        path: '/userManagement',
        name: 'C端用户管理',
        component: () => import('../views/userManagement/ManagementHome'),
        redirect: '/userManagement/management',
        children: [
            {
                path: 'management',
                name: '用户管理',
                component: () => import('../views/userManagement/Management')
            }
        ]
    },
    {
        path: '/activity',
        name: '学校活动',
        component: () => import('../views/schoolActivity/activityHome'),
        redirect: '/activity/schoolList',
        children: [
            {
                path: 'schoolList',
                name: '学校管理',
                component: () => import('../views/schoolActivity/schoolList')
            }
        ]
    },
    {
        path: '/faq',
        name: 'FAQ',
        component: FaqHome,
        redirect: '/faq/records',
        children: [
            {
                path: 'records',
                name: 'FAQ记录',
                component: faq
            },
        ]
    },
    {
        path: '/shop',
        name: '商店',
        component: () => import('../views/shop/shopHome'),
        redirect: '/shop/shop',
        children: [
            {
               path: '/shop/shop',
               name: '店铺管理',
               component: () => import('../views/shop/shopList'),
			   children: [
				   {
				        path: '/shop/shop/manager',
				        name: '装扮管理',
				        component: () => import('../views/shop/shopManagement'),
						children: [
							{
								 path: '/shop/shop/manager/edit',
								 name: '装扮编辑',
								 component: () => import('../views/shop/props'),
							 },
						]
				    }
			   ]
           },
		   {
                path: 'sort',
                name: '装扮排序',
                component: () => import('../views/shop/shopSort')
            },
            {
                 path: 'suit',
                 name: '套装管理',
                 component: () => import('../views/shop/suitManager')
             },
            {
                 path: 'role',
                 name: '人设馆管理',
                 component: () => import('../views/shop/roleManager')
             },
            {
                path: 'props',
                name: '道具管理',
                component: () => import('../views/shop/props')
            },
        ]
    },
    {
        path: '/furniture',
        name: '家具城',
        component: () => import('../views/furniture/shopHome'),
        redirect: '/furniture/shop',
        children: [
            {
               path: '/furniture/shop',
               name: '空间-店铺管理',
               component: () => import('../views/furniture/shopList'),
			   children: [
				   {
				        path: '/furniture/shop/manager',
				        name: '装扮管理',
				        component: () => import('../views/furniture/shopManagement'),
						children: [
							{
								 path: '/furniture/shop/manager/edit',
								 name: '装扮编辑',
								 component: () => import('../views/furniture/props'),
							 },
						]
				    }
			   ]
           },
		   {
                path: 'sort',
                name: '空间-装扮排序',
                component: () => import('../views/furniture/shopSort')
            },
            {
                path: '/furniture/personal/shop',
                name: '家-店铺管理',
                component: () => import('../views/furniture/personal/shopList'),
                children: [
                   {
                        path: '/furniture/personal/shop/manager',
                        name: '装扮管理',
                        component: () => import('../views/furniture/personal/shopManagement'),
                    }
                ]
            },
            {
                path: '/furniture/personal/sort',
                name: '家-装扮排序',
                component: () => import('../views/furniture/personal/shopSort')
            },
        ]
    },
    {
        path: '/factory',
        name: '工厂',
        component: () => import('../views/factory/factoryHome'),
        redirect: '/factory/factory',
        children: [
            {
               path: '/factory/factory',
               name: '工厂管理',
               component: () => import('../views/factory/factoryManager')
           },
            {
                path: 'props',
                name: '道具管理',
                component: () => import('../views/factory/props')
            },
        ]
    },
    {
        path: '/calendar',
        name: '打卡日历',
        component: CalendarHome,
        redirect: '/calendar/text',
        children: [
            {
                path: 'text',
                name: '文案',
                component: calendarText
            },
            {
                path: 'img',
                name: '图片',
                component: calendarImg
            },
        ]
    }

]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})

export default router
